<div class="wrapper" style="max-width: 500px">
  <div class="header">
    <h4>{{ documentName }}</h4>
  </div>
  <div class="subtitle">
    <p>{{ documentDescription }}</p>
  </div>
  <div class="attachmentsContainer" *ngIf="attachments && attachments.length">
    <div class="attachmentsTitle">Attachments:</div>
    <div class="attachmentContainer">
      <div class="attachment" *ngFor="let doc of attachments; let i = index" (click)="viewAttachment(doc.id)">
        <div>
          {{ doc.file_name }}
        </div>
        <svg
          class="open"
          fill="none"
          height="16"
          viewBox="0 0 16 16"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <rect fill="url(#pattern0)" fill-opacity="0.5" height="16" width="16" />
          <defs>
            <pattern height="1" id="pattern0" patternContentUnits="objectBoundingBox" width="1">
              <use transform="scale(0.005)" xlink:href="#image0" />
            </pattern>
            <image
              height="200"
              id="image0"
              width="200"
              xlink:href="data:image/png;base64,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"
            />
          </defs>
        </svg>
      </div>
    </div>
  </div>
  <div class="body">
    <div *ngIf="tempUploadedDocuments.length === 0 && !disabledCtrl.get('disabled').value" class="uploadPad">
      <form #form class="uploadForm">
        <input
          (change)="onFileEvent($event)"
          (click)="onFileEvent($event)"
          [accept]="acceptedFileTypes"
          class="upload"
          data-cy="upload-button.component.uploadFile"
          name="myfile"
          type="file"
        />
      </form>
      <span>Drag file here or <span id="browse">Browse</span></span>
      <span id="file-type">All file types allowed</span>
      <span id="subtitle">Max file size: 20MB</span>
    </div>
    <div [hidden]="tempUploadedDocuments.length === 0 || disabledCtrl.get('disabled').value" class="documentsWrapper">
      <div
        (click)="viewDocument(i); $event.stopPropagation()"
        *ngFor="let doc of tempUploadedDocuments; let i = index"
        class="document"
      >
        <span [attr.data-cy]="'due-diligence-file-upload-modal.component.fileName'"
          >{{ doc.file_name || doc.filename | fileNamePipe }}
          <svg
            class="open"
            fill="none"
            height="16"
            viewBox="0 0 16 16"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <rect fill="url(#pattern0)" fill-opacity="0.5" height="16" width="16" />
            <defs>
              <pattern height="1" id="pattern0" patternContentUnits="objectBoundingBox" width="1">
                <use transform="scale(0.005)" xlink:href="#image0" />
              </pattern>
              <image
                height="200"
                id="image0"
                width="200"
                xlink:href="data:image/png;base64,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"
              />
            </defs>
          </svg>
        </span>
        <svg
          (click)="removeDocument(i); $event.stopPropagation()"
          class="delete"
          fill="none"
          height="17"
          viewBox="0 0 17 17"
          width="17"
          xmlns="http://www.w3.org/2000/svg"
          data-cy="due-diligence-file-upload-modal.component.remove-document"
        >
          <circle cx="8.5" cy="8.5" fill="#F0F2F9" r="8" stroke="#DBE1ED" />
          <path d="M6 6L10.7472 10.7472" stroke="#9B9EB1" stroke-linecap="round" />
          <path d="M6.00098 10.7471L10.7482 5.99984" stroke="#9B9EB1" stroke-linecap="round" />
        </svg>
      </div>
      <div class="additionalDocUpload">
        <form #form2 class="uploadForm">
          <input
            (change)="onFileEvent($event)"
            [accept]="acceptedFileTypes"
            class="uploadAdditional"
            data-cy="upload-button.component.uploadFile"
            name="myfile"
            type="file"
          />
        </form>
        <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
          <path
            clip-rule="evenodd"
            d="M7.28571 3V7.28571H3V8.71429H7.28571V13H8.71429V8.71429H13V7.28571H8.71429V3H7.28571Z"
            fill="#02B45B"
            fill-rule="evenodd"
          />
          <circle cx="8" cy="8" r="7.5" stroke="#02B45B" />
        </svg>
        <span>Upload Additional Documents</span>
      </div>
    </div>
    <div *ngIf="disabledCtrl.get('disabled').value" class="textArea">
      <mat-form-field [formGroup]="disabledCtrl">
        <textarea
          #autosize="cdkTextareaAutosize"
          cdkAutosizeMaxRows="5"
          cdkAutosizeMinRows="1"
          cdkTextareaAutosize
          formControlName="comment"
          matInput
          placeholder="Add a comment (required)"
          data-cy="upload-button.component.add-comment"
        ></textarea>
      </mat-form-field>
    </div>
  </div>
  <div *ngIf="tempUploadedDocuments.length === 0" [formGroup]="disabledCtrl" class="checkboxWrapper">
    <mat-checkbox data-cy="upload-button.component.checkbox" formControlName="disabled"
      >I don't have this document</mat-checkbox
    >
  </div>
  <div class="buttonWrapper">
    <gcv-button (clickEvent)="close()" buttonText="Cancel" type="tertiary"></gcv-button>
    <gcv-button
      (clickEvent)="save()"
      *ngIf="!disabledCtrl.get('disabled').value"
      [disabled]="tempUploadedDocuments.length === 0"
      buttonText="Finish"
      id="saveButton"
    ></gcv-button>
    <gcv-button
      (clickEvent)="save()"
      *ngIf="disabledCtrl.get('disabled').value"
      [disabled]="!disabledCtrl.valid"
      buttonText="Finish"
    ></gcv-button>
  </div>
</div>
